import { render, staticRenderFns } from "./directorInfo.vue?vue&type=template&id=3ef6c2f8&scoped=true&"
import script from "./directorInfo.vue?vue&type=script&lang=js&"
export * from "./directorInfo.vue?vue&type=script&lang=js&"
import style0 from "./directorInfo.vue?vue&type=style&index=0&id=3ef6c2f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef6c2f8",
  null
  
)

export default component.exports